module.exports = __webpack_public_path__ + "media/icons/plus-df834c39.svg";